import { CommonKeys } from "../../common/enums";
import { FORMULAR_GROUPS_TYPE } from "../../common/formular-group-types";
import { FORMULAR_GROUP_ARTIKEL_SCHEMAS } from "./FormularGroupArtikel";
import { FORMULAR_GROUP_BERICHTE_SCHEMAS } from "./FormularGroupBerichte";
import { FORMULAR_GROUP_DYNAMIC_INPUTS_SCHEMAS } from "./FormularGroupDynamicFields";
import { FORMULAR_GROUP_INPUTS_SCHEMAS } from "./FormularGroupInputs";
import { FORMULAR_GROUP_SIGNATUREN_SCHEMAS } from "./FormularGroupSignaturen";
import { FORMULAR_GROUP_STAMM_SCHEMAS } from "./FormularGroupStamm";
import { FORMULAR_GROUP_WARTUNGEN_SCHEMAS } from "./FormularGroupWartungen";
import { FORMULAR_GROUP_ZEITERFASSUNG_SCHEMAS } from "./FormularGroupZeiterfassung";

export const FormularModelGroupsSchema = {
    $id: "FormularModelGroupsSchema",
    title: "FormularModelGroups Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUPS_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: {
                anyOf: [
                    { $ref: "FormularGroupStammSchema" },
                    { $ref: "FormularGroupInputsSchema" },
                    { $ref: "FormularGroupBerichteSchema" },
                    { $ref: "FormularGroupWartungenSchema" },
                    { $ref: "FormularGroupZeiterfassungSchema" },
                    { $ref: "FormularGroupSignaturenSchema" },
                    { $ref: "FormularGroupArtikelSchema" },
                    { $ref: "FormularGroupDynamicFieldsSchema" },
                ]
            }
        }
    }
}

export const FORMULAR_GROUP_SCHEMAS = [
    FormularModelGroupsSchema,
    ...FORMULAR_GROUP_STAMM_SCHEMAS,
    ...FORMULAR_GROUP_BERICHTE_SCHEMAS,
    ...FORMULAR_GROUP_INPUTS_SCHEMAS,
    ...FORMULAR_GROUP_WARTUNGEN_SCHEMAS,
    ...FORMULAR_GROUP_ZEITERFASSUNG_SCHEMAS,
    ...FORMULAR_GROUP_SIGNATUREN_SCHEMAS,
    ...FORMULAR_GROUP_ARTIKEL_SCHEMAS,
    ...FORMULAR_GROUP_DYNAMIC_INPUTS_SCHEMAS
]